import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LucideAngularModule } from 'lucide-angular';
import { providePrimeNG } from 'primeng/config';
import { lucideIcons } from './icons.provider';
import { AllToTripsPreset } from './app.theme';
import { routes } from './app.routes';
import { authorizationInterceptor } from './core/auth/authorization.interceptor';
import { maintenanceInterceptor } from './core/maintenance/maintenance.interceptor';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([maintenanceInterceptor, authorizationInterceptor])),
    provideRouter(routes),
    importProvidersFrom(LucideAngularModule.pick(lucideIcons)),
    providePrimeNG({
      theme: {
        preset: AllToTripsPreset,
        options: {
          darkModeSelector: false,
        },
      },
      ripple: true,
    }),
  ],
};
